import { useQuery } from "@tanstack/react-query";
import { axiosInterceptor } from "..";
import { SessionOverviewResponse } from "../interface";

const fetchLevelData = async (
  orgId: string,
  feedbackId: string
): Promise<SessionOverviewResponse> => {
  const { data } = await axiosInterceptor.get(
    `progression-b2b/${orgId}/${feedbackId}/session-overview`
  );
  return data;
};

const useSessionOverview = (orgId?: string, feedbackId?: string) => {
  return useQuery({
    queryKey: ["session-overview", orgId, feedbackId],
    queryFn: () => {
      if (!orgId || !feedbackId)
        return Promise.reject("Missing orgId or subUserId");
      return fetchLevelData(orgId, feedbackId);
    },
    enabled: !!orgId && !!feedbackId,
  });
};

export default useSessionOverview;
